<template>
    <div>
        <v-tabs  vertical>
            <v-tab>
                Προφίλ χρήστη
            </v-tab>
            <v-tab>
                Ρυθμίσεις
            </v-tab>
            <v-tab-item class="ma-4">
                <v-card class="mb-4" max-width="700px" >
                    <v-toolbar flat>
                        <v-toolbar-title> Στοιχεία Χρήστη</v-toolbar-title>
                    </v-toolbar>
                    <v-list nav>
                        <v-list-item dense>
                            <v-list-item-action>
                                <v-icon>mdi-account</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>
                                    Όνομα χρήστη
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    {{userDetails.Username}}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item dense>
                            <v-list-item-action>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>
                                    Όνοματεπώνυμο
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ userDetails.FullName}}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
                <change-password/>
            </v-tab-item>
            <v-tab-item class="ma-4">
                <v-card>
                    <v-card-text>
                        <v-list>
                            <v-list-item>
                                <v-list-item-action>
                                    <enable-notifications/>
                                </v-list-item-action>
                                <v-list-item-content>
                                    Ενεργοποίηση ειδοποιήσεων στην συσκευή.
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                </v-card>
            </v-tab-item>
        </v-tabs>
        <portal to="toolbar-title">Προφίλ Χρήστη</portal>
        <portal to="toolbar-actions">
        </portal>
    </div>

</template>

<script>
    import ChangePassword from "../components/ChangePassword";
    import {mapGetters} from "vuex";
    import EnableNotifications from "../components/EnableNotifications";

    export default {
        name: "UserDetails",
        components: {EnableNotifications, ChangePassword},
        computed: {
            ...mapGetters([
                "userDetails",
            ])
        }
    }
</script>

<style scoped>

</style>
